import { get } from 'lodash';
import { useFind, usePopulate } from 'api/APIHooks';

export const useClientDetailsCard = (person, serviceAuthorization, providerId) => {
  const { data: clientRelationshipData, isSuccess: isClientRelationshipLoaded } = useFind(
    'client_relationship',
    { person: person.id, provider: providerId },
    { queryConfig: { enabled: !!person.id && !!providerId, placeholderData: undefined } },
  );

  const { isSuccess: isSocialCareCoverageLoaded } = usePopulate(
    'insurance',
    'insurance',
    serviceAuthorization,
    { queryConfig: { placeholderData: undefined } },
  );

  const { isSuccess: isSocialCareCoveragePlanLoaded } = usePopulate(
    'insurance.plan',
    'plan',
    serviceAuthorization,
    { queryConfig: { placeholderData: undefined } },
  );

  const { isSuccess: isPrimaryHealthInsuranceLoaded } = usePopulate(
    'insurance.primary_health_insurance',
    'insurance',
    serviceAuthorization,
    { queryConfig: { placeholderData: undefined } },
  );

  usePopulate(
    'fee_schedule_program',
    'fee_schedule_program',
    serviceAuthorization,
    { queryConfig: { placeholderData: undefined } },
  );

  const { isSuccess: isFeeScheduleLoaded } = usePopulate(
    'fee_schedule_program.fee_schedule',
    'fee_schedule',
    serviceAuthorization,
    { queryConfig: { placeholderData: undefined } },
  );

  const { isSuccess: isConsentLoaded } = usePopulate(
    'consent',
    'consent',
    person,
    { queryConfig: { placeholderData: undefined } },
  );

  return {
    clientRelationships: get(clientRelationshipData, 'data.data', []),
    isClientRelationshipLoaded,
    isSocialCareCoverageLoaded,
    isSocialCareCoveragePlanLoaded,
    isPrimaryHealthInsuranceLoaded,
    isFeeScheduleLoaded,
    isConsentLoaded,
  };
};
